import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import {SmContextMenuItemComponent} from './sm-context-menu-item.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
  ],
  declarations: [SmContextMenuItemComponent],
  exports: [SmContextMenuItemComponent],
})
export class SmContextMenuItemModule {}
